import React__default, { useState, useEffect } from 'react';
import classNames from 'classnames';
import 'bootstrap/dist/css/bootstrap.css';
import '../../../styles/forms.css.js';
import './input.scss.js';
import { styled } from 'styled-components';

const InputStyled = styled.input `
  box-shadow: none !important;
  outline: none !important;

  &:focus {
    border-color: #8a00e5 !important;
  }
`;
const InputComponent = ({ size = 'medium', readonly = false, disabled = false, width = '100%', defaultValue = '', ...props }) => {
    const [text, setText] = useState(defaultValue);
    useEffect(() => {
        setText(defaultValue);
    }, [defaultValue]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(InputStyled, { autoFocus: props.autofocus, id: props.id, maxLength: props.maxLength, minLength: props.minLength, name: props.id, value: text, placeholder: props.placeholder, readOnly: readonly, disabled: disabled, onChange: e => {
                setText(e.target.value);
                if (props.onChange) {
                    props.onChange(e);
                }
            }, onClick: props.onClick, onFocus: props.onFocus, onBlur: props.onBlur, onInput: props.onInput, onKeyDown: props.onKeyDown, onKeyPress: props.onKeyPress, onKeyUp: props.onKeyUp, autoComplete: "off", style: { width: width }, className: classNames('form-control', props.className, {
                'form-control-xs': size === 'extra-small',
                'form-control-sm': size === 'small',
                'form-control-lg': size === 'large',
                'input-with-prepend': props.textBefore,
                'input-with-append': props.textAfter,
            }) })));
};
const CheckInput = (props) => {
    if (props.textAfter && props.textBefore) {
        return (React__default.createElement("div", { style: { display: 'grid', gridTemplateColumns: 'auto 1fr auto' } },
            React__default.createElement("div", { className: "label-added prepend noselect" }, props.textBefore),
            React__default.createElement("div", null,
                React__default.createElement(InputComponent, { ...props })),
            React__default.createElement("div", { className: "label-added append noselect" }, props.textAfter)));
    }
    else if (props.textBefore) {
        return (React__default.createElement("div", { style: { display: 'grid', gridTemplateColumns: 'auto 1fr' } },
            React__default.createElement("div", { className: "label-added prepend noselect" }, props.textBefore),
            React__default.createElement("div", null,
                React__default.createElement(InputComponent, { ...props }))));
    }
    else if (props.textAfter) {
        return (React__default.createElement("div", { style: { display: 'grid', gridTemplateColumns: '1fr auto' } },
            React__default.createElement("div", null,
                React__default.createElement(InputComponent, { ...props })),
            React__default.createElement("div", { className: "label-added append noselect" }, props.textAfter)));
    }
    else {
        return React__default.createElement(InputComponent, { ...props });
    }
};
const Input = (props) => {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "reactLib__Input", style: { width: props.width } },
            props.label ? (React__default.createElement("label", { style: { textAlign: 'left' }, htmlFor: props.id }, props.label)) : null,
            React__default.createElement(CheckInput, { ...props }))));
};

export { Input as default };
//# sourceMappingURL=Input.js.map
